import { useState } from "react";
import { useSelector } from "react-redux";
import I18n from "i18n-js";
import { RootState } from "app/store";
import { usePlaySound } from "common/utils";
import { WarningMessageBox } from "common/elements";
import { CreateChildUser } from "features/auth/CreateChildUser";
import { IconUserAdd, IconUserAddInvalid } from "features/user/assets";
import { BillingType, BILLING_LIMIT_ACCOUNT } from "features/user/types";

export const CreateParentsKidsUser = () => {
  const play = usePlaySound();
  const [newUser, setNewUser] = useState(false);
  const [maxUser, setMaxUser] = useState(false);
  const users = useSelector((state: RootState) => state.user.users);
  const parent = useSelector((state: RootState) => state.user.parent);

  const handleOpenAddNewUser = () => {
    play();
    if (parent.billing_type === BillingType.EDUCATION) {
      if (users.length > BILLING_LIMIT_ACCOUNT.EDUCATION) {
        setMaxUser(true);
      } else {
        setNewUser(true);
      }
    } else {
      if (users.length > 2) {
        setMaxUser(true);
      } else {
        setNewUser(true);
      }
    }
  };

  const handleCloseWarning = () => {
    play();
    setMaxUser(false);
  };

  const handleCloseCreateUser = () => {
    setNewUser(false);
  };

  return (
    <>
      <CreateChildUser open={newUser} close={handleCloseCreateUser} />

      {maxUser && (
        <WarningMessageBox
          zIndex={999999}
          title={I18n.t("MSG_SETTING_PARENTS_MAX_USER_TITLE")}
          message={I18n.t("MSG_SETTING_PARENTS_MAX_USER_MESSAGE")}
          close={handleCloseWarning}
        />
      )}

      <div className="flex-row-el w-full h-0.5 shrink-0 px-[10%] my-4">
        <div className="flex-row-el w-full h-full bg-gray2-60" />
      </div>

      <div className="flex-row-center">
        <button
          onClick={handleOpenAddNewUser}
          className="opacity-button w-[92px]"
        >
          <div className="flex-row-el items-center justify-start">
            <div className="flex-col-center w-[80px] h-[80px]">
              {users.length < 5 ? <IconUserAdd /> : <IconUserAddInvalid />}
            </div>
            <div className="flex-col-el w-[250px] px-4">
              <p className="text-body text-left text-textcolor-black text-font-size-body2-narrow w-full text-body-ellipsis">
                {I18n.t("MSG_SETTING_PARENTS_USER_PROFILE_ADD_USER")}
              </p>
            </div>
          </div>
        </button>
      </div>
    </>
  );
};
